export default {
  title: "Authentication",
  signIn: "Sign in",
  signUp: "Sign up",
  signOut: "Sign out",
  login: {
    title: "Login",
    description: "Log in to your account",
    form: {
      email: "Email",
      password: "Password",
      rememberMe: "Remember me",
      submit: "Log in",
      forgotPassword: "Forgot password?"
    },
    errors: {
      invalidCredentials: "Incorrect email or password",
      userNotFound: "No account found with this email",
      tooManyAttempts: "Too many attempts, please try again later"
    }
  },
  logout: "Logout",
  register: {
    title: "Sign up",
    description: "Create your account",
    form: {
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm password",
      terms: "I accept the terms of use",
      submit: "Register"
    },
    errors: {
      emailExists: "An account already exists with this email",
      passwordTooWeak: "Password is too weak",
      passwordsDontMatch: "Passwords do not match",
      termsNotAccepted: "You must accept the terms of use"
    }
  },
  forgotPassword: {
    title: "Forgot password",
    description: "Reset your password",
    form: {
      email: "Email",
      submit: "Send reset link"
    },
    success: "A reset email has been sent",
    errors: {
      userNotFound: "No account found with this email",
      tooManyAttempts: "Too many attempts, please try again later"
    }
  },
  resetPassword: {
    title: "Reset password",
    description: "Choose a new password",
    form: {
      password: "New password",
      confirmPassword: "Confirm password",
      submit: "Reset password"
    },
    success: "Your password has been reset",
    errors: {
      invalidToken: "The reset link is invalid or has expired",
      passwordTooWeak: "Password is too weak",
      passwordsDontMatch: "Passwords do not match"
    }
  },
  email: "Email",
  password: "Password",
  confirmPassword: "Confirm password",
  username: "Username",
  fullName: "Full name",
  firstName: "First name",
  lastName: "Last name",
  rememberMe: "Remember me",
  dontHaveAccount: "Don't have an account?",
  alreadyHaveAccount: "Already have an account?",
  loginButton: "Login",
  registerButton: "Register",
  loginWithGoogle: "Login with Google",
  loginWithFacebook: "Login with Facebook",
  registerWithGoogle: "Register with Google",
  registerWithFacebook: "Register with Facebook",
  or: "or",
  loginHere: "Login here",
  registerHere: "Register here",
  sendResetEmail: "Send Reset Email",
  backToLogin: "Back to Login",
  checkEmail: "Check your email",
  resetEmailSent: "Password reset email sent",
  passwordReset: {
    title: "Password reset",
    success: "Reset email sent",
    error: "Error resetting password",
    submit: "Send reset email"
  },
  errors: {
    invalidEmail: "Invalid email",
    weakPassword: "Password too weak",
    passwordMismatch: "Passwords don't match",
    passwordsMismatch: "Passwords do not match",
    emailAlreadyInUse: "This email is already in use",
    userNotFound: "User not found",
    wrongPassword: "Incorrect password",
    genericError: "Authentication error",
    tooManyRequests: "Too many attempts, please try again later",
    popupClosed: "Popup window closed. Please try again.",
    accountExistsWithDifferentCredential: "An account already exists with another login method",
    socialLoginFailed: "Social login failed",
    loginFailed: "Login failed",
    googleLoginFailed: "Google login failed",
    facebookLoginFailed: "Facebook login failed",
    default: "An error occurred during authentication",
    emailInUse: "This email address is already in use",
    networkError: "Network error. Check your internet connection.",
    operationNotAllowed: "This operation is not allowed",
    popupCancelled: "Popup window was cancelled",
    accountExists: "An account already exists with this email address",
    googleSignIn: "Error signing in with Google",
    recaptchaFailed: "reCAPTCHA verification failed",
    suspiciousActivity: "Suspicious activity detected",
    disallowedUserAgent: "This browser is not supported for login",
    recaptchaUnavailable: "Security service is temporarily unavailable. Please try again later.",
    recaptchaTimeout: "Security verification took too long. Please check your connection and try again.",
    invalidPhone: "Invalid phone number",
    invalidCode: "Invalid code, please enter the 6 digits.",
    emailNotFound: "Email not found. Please retry the registration process.",
    verificationFailed: "Verification failed. Please try again.",
    invalidLink: "Invalid verification link.",
    pendingInvitation: "Error checking pending invitations",
    accept: "Error accepting invitation",
    decline: "Error declining invitation",
    loadInvitation: "Error loading invitation",
    emailRequired: "Email is required",
    passwordRequired: "Password is required",
    passwordTooShort: "Password must be at least 6 characters",
    loginError: "Login error",
    registrationError: "Registration error",
    resetPasswordError: "Reset password error",
    socialLoginError: "Social login error",
    emailAlreadyExists: "Email already exists"
  },
  loggingIn: "Logging in...",
  continueWith: "Continue with",
  createAccount: {
    title: "Create account",
    description: "Create an account to manage your wedding",
    benefits: "Benefits of creating an account",
    submit: "Create account"
  },
  signInWithGoogle: "Sign in with Google",
  continueAsGuest: "Continue as guest",
  webViewWarning: "Login may not work properly in some embedded browsers. Please use your main browser.",
  termsNotice: "By continuing, you accept our",
  termsOfService: "Terms of Service",
  and: "and",
  privacyPolicy: "Privacy Policy",
  protectedBy: "Protected by reCAPTCHA",
  facebook: {
    accountExists: {
      title: "Existing account detected",
      description: "It seems you already have an account with the same email address but with a different login method.",
      step1: "Try logging in with your usual method (email/password, Google, etc.)",
      step2: "If you don't remember your login method, use the 'Forgot password' option with your email address."
    },
    general: {
      title: "Tips for Facebook login",
      tip1: "Make sure third-party cookies are enabled in your browser",
      tip2: "Try using a different browser",
      tip3: "Make sure your Facebook account is active and in good standing",
      tip4: "Check your internet connection",
      tip5: "Try logging out of Facebook and then logging back in",
      privacy: "Privacy",
      privacyText: "We only access your name and email. We never post to your Facebook account without your explicit permission."
    },
    popupBlocked: {
      title: "Popup blocked",
      description: "Your browser has blocked the Facebook login popup. Please allow popups for this site.",
      step1: "Look for the popup blocker icon in your browser's address bar",
      step2: "Click the icon and select 'Always allow popups from this site'",
      step3: "Try logging in again",
      note: "Note",
      noteText: "On some mobile devices, popups may not work properly. If you encounter problems, try using a desktop computer."
    },
    unauthorizedDomain: {
      title: "Unauthorized domain",
      description: "It seems you're accessing the app from a domain that is not authorized for Facebook authentication.",
      note: "Note",
      noteText: "This error usually occurs when you access the app from a test domain or development environment."
    },
    understood: "I understand"
  },
  loginWithApple: "Login with Apple",
  signupWithGoogle: "Sign up with Google",
  signupWithFacebook: "Sign up with Facebook",
  signupWithApple: "Sign up with Apple",
  verifyPhone: "Verify your phone",
  verifyPhoneMessage: "Enter your phone number to receive a verification code via SMS",
  phoneNumber: "Phone number",
  phoneNumberFormat: "Without the first zero for France, ex: 612345678",
  skipStep: "Skip this step for now",
  verifySms: "Verify SMS code",
  verifySmsMessage: "We sent a 6-digit code to the number",
  resendCodeIn: "Resend code in",
  resendCode: "Resend code",
  verifyEmail: {
    title: "Verify email",
    description: "Verify your email address",
    success: "Your email has been verified",
    resend: "Resend verification email",
    errors: {
      invalidToken: "The verification link is invalid or has expired",
      alreadyVerified: "This email is already verified"
    }
  },
  verifyEmailMessage: "We sent a 6-digit code to",
  verifyingEmail: "Verifying email...",
  tryAgain: "Try again",
  redirecting: "Redirecting...",
  noCodeReceived: "Didn't receive a code?",
  emailVerificationRequired: "Email verification required",
  emailVerificationSent: "Verification email sent",
  resendVerification: "Resend Verification",
  emailVerified: "Email verified successfully",
  verificationError: "Verification error",
  continueWithEmail: "Continue with email",
  continueWithPassword: "Continue with password",
  terms: "Terms of Service",
  privacy: "Privacy Policy",
  agreeToTerms: "I agree to the Terms of Service and Privacy Policy",
  termsRequired: "You must agree to the terms and conditions",
  welcome: "Welcome",
  welcomeBack: "Welcome back",
  pleaseWait: "Please wait...",
  loading: "Loading...",
  invalidCredentials: "Invalid credentials",
  loginSuccess: "Login successful",
  registrationSuccess: "Registration successful",
  logoutSuccess: "Logout successful",
  accessLevels: {
    view: "View only",
    edit: "Edit",
    manage: "Full management"
  },
  accessInfo: {
    connectedAs: "Connected as"
  },
  accessRestriction: {
    title: "Access restricted",
    insufficientLevel: "Insufficient access level",
    login: "Login",
    needsLevel: "Needs level",
    description: "You do not have the required permission level."
  },
  currentLevel: "Current level",
  requiredLevel: "Required level",
  oauth: {
    google: "Continue with Google",
    facebook: "Continue with Facebook",
    apple: "Continue with Apple"
  },
  messages: {
    loggedIn: "Logged in successfully",
    loggedOut: "Logged out successfully",
    registered: "Account created successfully",
    emailVerified: "Email verified successfully",
    passwordReset: "Password reset successfully"
  }
};
